import React, { useContext } from "react";
import { Button, Row, Container } from "react-bootstrap";
import { Cart4 } from "react-bootstrap-icons";
import "../../assets/styles/Cart.css";
import { StateContext } from "../../contexts/StateContext";
import CartList from "./CartList";
import CartTotal from "./CartTotal";

const Cart = ({ checkout }) => {
  const { cart, user, setShowLoginModal, setShowOrder } =
    useContext(StateContext);

  return (
    <>
      <Row>
        <h5 className="align-middle mt-1 text-success">Order</h5>
        {!checkout && <hr className="border border-dark" />}
      </Row>
      {cart.items.length === 0 ? (
        <div className="h-100 scrollable overflow-auto m-0">
          <Cart4
            color="grey"
            size={100}
            className="position-relative top-50 start-50 translate-middle"
          />
        </div>
      ) : (
        <div className="h-100 scrollable overflow-auto m-0">
          <CartList cart={cart} />
          <CartTotal cart={cart} />
          {!checkout && (
            <Button
              variant="outline-primary"
              className="float-end mb-4"
              onClick={() => {
                if (user) {
                  setShowOrder(true);
                } else {
                  setShowLoginModal(true);
                }
              }}
            >
              BUY
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default Cart;
